import type { InternalUserProfile } from '../../../services/userProfile';
import type { RightToInformationWizardDraft } from '../../../types/rightToInformationCaseRequest';

export type RightToInformationSubmissionFields = Pick<
  RightToInformationWizardDraft,
  | 'submittedByUserId'
  | 'submittedByDisplayName'
  | 'submittedAgencyName'
  | 'submittedDivisionName'
  | 'submitterDesignation'
  | 'submitterEmail'
  | 'submitterContactNo'
>;

export function submissionFieldsFromInternalProfile(
  profile: InternalUserProfile,
): RightToInformationSubmissionFields {
  const displayName =
    profile.userDisplayName.trim() ||
    [profile.firstName, profile.lastName].filter(Boolean).join(' ').trim() ||
    profile.username;

  return {
    submittedByUserId: profile.appUserId,
    submittedByDisplayName: displayName,
    submittedAgencyName: '',
    submittedDivisionName: profile.divisionName,
    submitterDesignation: profile.designation,
    submitterEmail: profile.username,
    submitterContactNo: profile.contactNumber,
  };
}

export function applySubmissionFieldsToDraft(
  draft: RightToInformationWizardDraft,
  fields: RightToInformationSubmissionFields,
): RightToInformationWizardDraft {
  return { ...draft, ...fields };
}
